module.exports = __webpack_public_path__ + "img/yml_gallery14.5aca338c.jpg";